import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpLoaderService {

  private pendingRequests = 0;
  readonly visible = signal(false);

  notifyRequestStart(): void {
    this.pendingRequests += 1;
    this.updateVisibility();
  }

  notifyRequestEnd(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    this.updateVisibility();
  }

  private updateVisibility(): void {
    this.visible.set(this.pendingRequests > 0);
  }
}
